module.exports = __webpack_public_path__ + "img/arrow-left-blue.c5083f78.svg";